import React, { useMemo, useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import Item from "./poll/item";
import DuplicateDialog from "../components/dialogs/duplicateDialog";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import usePollSettings from "./usePollSettings";
import { createDateFromDDMMYYYY } from "@icarius-utils/date";

const PollSettings = ({ history }) => {

  const [viewFiltered, setViewFiltered] = useState(true);
  const {
    isLoading,
    polls,
    visualizationTypeList,
    modes,
    processList,
    pollTypes,
    onaTypeList,
    positionList,
    createPollIsOpen,
    duplicateData,
    isImport,
    employeeList,
    setCreatePollIsOpen,
    handleOpenDuplicationDialog,
    handleCloseDuplicationDialog,
    exportPoll,
    importPoll,
  } = usePollSettings();

  const customItems = (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={viewFiltered}
            onChange={() => setViewFiltered(prev => !prev)}
            value={viewFiltered}
            color="primary"
          />
        }
        label={viewFiltered ? getLocalizedString("activePluralFemale") : getLocalizedString("all")}
        labelPlacement="start"
        style={{ marginRight: 5 }}
      />
      <CustomIconButton
        title={getLocalizedString("goBack")}
        onClick={() => history.push(paths.pollScreenSelector)}
        type={"goBack"}
      />
      <CustomIconButton
        title={getLocalizedString("importSurvey")}
        onClick={importPoll}
        type={"upload"}
      />
    </>
  )

  const pollNames = polls?.map((poll) => poll.name) || [];

  const getIsActive = ({ startDate, endDate }) => {
    const newEndDate = createDateFromDDMMYYYY(endDate).setHours(0, 0, 0, 0).valueOf();
    const newStartDate = createDateFromDDMMYYYY(startDate).setHours(0, 0, 0, 0).valueOf();
    const today = new Date().setHours(0, 0, 0, 0).valueOf();

    return today >= newStartDate && today <= newEndDate;
  }

  const filteredPolls = useMemo(() => {
    if (!viewFiltered) return polls;
    return polls.filter(getIsActive);
  }, [polls, viewFiltered])

  return (
    <ABMLayout
      title={getLocalizedString("pollSettings")}
      isLoading={isLoading}
      showCreateButton={!createPollIsOpen}
      createButtonTitle={getLocalizedString("newPoll")}
      createButtonOnClick={() => setCreatePollIsOpen(true)}
      customItems={[customItems]}
      useCustomItemsEnd
    >
      {
        createPollIsOpen &&
        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
          <Item
            data={null}
            visualizationTypeList={visualizationTypeList}
            pollTypes={pollTypes}
            modes={modes}
            closeNewPoll={() => setCreatePollIsOpen(false)}
            isLoading={isLoading}
            pollNames={pollNames}
            processList={processList}
            positionList={positionList}
            onaTypeList={onaTypeList}
            employeeList={employeeList}
          />
        </Grid>
      }
      {
        filteredPolls.map((poll) =>
          <Grid container item xs={12} style={{ margin: "10px 0px" }} key={poll.code}>
            <Item
              openDuplicateDialog={(data) => handleOpenDuplicationDialog(data)}
              data={poll}
              visualizationTypeList={visualizationTypeList}
              pollTypes={pollTypes}
              modes={modes}
              isLoading={isLoading}
              exportPoll={exportPoll}
              pollNames={pollNames}
              processList={processList}
              getIsActive={getIsActive}
              positionList={positionList}
              onaTypeList={onaTypeList}
              employeeList={employeeList}
            />
          </Grid>
        )
      }
      {
        Boolean(duplicateData) &&
        <DuplicateDialog
          open={Boolean(duplicateData)}
          data={duplicateData}
          isImport={isImport}
          pollNames={pollNames}
          handleClose={handleCloseDuplicationDialog}
        />
      }
    </ABMLayout>
  )
}

export default PollSettings;